class ScheduledReportListCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    private scheduleLabel:MUILabel = null;
    private statusLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.scheduleLabel = MUIOutlet(this, "schedule-lbl", "MUILabel");
        this.statusLabel = MUIOutlet(this, "status-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:ScheduledReport = null;
    setItem(item:ScheduledReport, reportName:string){
        this._item = item;

        this.nameLabel.text = item.title ? item.title : (reportName ? reportName : MIOLocalizeString("REPORT", "REPORT"));
        this.scheduleLabel.text = MIOLocalizeString(item.recurrence.toUpperCase(), item.recurrence.toUpperCase()) + " · " + item.sendTime + " · " + MIOLocalizeString(item.period.toUpperCase().replace("-", "_"), item.period.toUpperCase());

        if (item.active == false) {
            this.statusLabel.text = MIOLocalizeString("INACTIVE", "INACTIVE");
        }
        else if (item.lastError != null) {
            this.statusLabel.text = MIOLocalizeString("ERROR", "ERROR");
        }
        else {
            this.statusLabel.text = "";
        }
    }
}
